<template>
  <footer class="bg-gray-50 dark:bg-gray-950 text-gray-900 dark:text-white py-12 border-t border-gray-200 dark:border-gray-800 relative z-10">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-8">
        <router-link 
          to="/" 
          class="inline-block transition-all duration-300 group"
          @mouseenter="isFooterNameHovered = true"
          @mouseleave="isFooterNameHovered = false"
        >
          <h3 
            class="text-2xl font-bold mb-2 transition-colors"
            :class="!accentColor && (isFooterNameHovered ? 'text-blue-600 dark:text-blue-400' : 'text-gray-900 dark:text-white')"
            :style="accentColor ? { color: accentColor } : {}"
          >
            RE<span 
              class="it-underline" 
              :class="!accentColor ? 'text-blue-600 dark:text-blue-400' : ''"
              :style="accentColor ? { color: accentColor } : {}"
            >IT</span>SBERGER
          </h3>
        </router-link>
        <p class="text-gray-500 dark:text-gray-400 text-sm font-medium tracking-widest uppercase">IT steckt im Namen</p>
      </div>

      <div class="border-t border-gray-100 dark:border-gray-800 pt-8">
        <div class="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 mb-6">
          <router-link 
            to="/impressum" 
            class="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors text-sm font-medium"
            :style="isImpressumHovered ? { color: accentColor } : {}"
            @mouseenter="isImpressumHovered = true"
            @mouseleave="isImpressumHovered = false"
          >
            Impressum
          </router-link>
          <span class="hidden md:inline text-gray-300 dark:text-gray-700">|</span>
          <router-link 
            to="/datenschutz" 
            class="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors text-sm font-medium"
            :style="isDatenschutzHovered ? { color: accentColor } : {}"
            @mouseenter="isDatenschutzHovered = true"
            @mouseleave="isDatenschutzHovered = false"
          >
            Datenschutz
          </router-link>
          <span class="hidden md:inline text-gray-300 dark:text-gray-700">|</span>
          <router-link 
            to="/contact" 
            class="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors text-sm font-medium"
            :style="isContactHovered ? { color: accentColor } : {}"
            @mouseenter="isContactHovered = true"
            @mouseleave="isContactHovered = false"
          >
            Kontakt
          </router-link>
        </div>

        <div class="text-center">
          <p class="text-gray-600 dark:text-gray-400 text-sm">
            &copy; {{ new Date().getFullYear() }} MAXIMILIAN REITSBERGER. <span class="block sm:inline">Alle Rechte vorbehalten.</span>
          </p>
          <p class="text-gray-400 dark:text-gray-600 text-xs mt-3 font-medium uppercase tracking-wider">
            Senior QA Specialist & Webentwickler | München, Deutschland
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { ref } from 'vue'

defineProps<{
  accentColor?: string
}>()

const isFooterNameHovered = ref(false)
const isImpressumHovered = ref(false)
const isDatenschutzHovered = ref(false)
const isContactHovered = ref(false)
</script>

<style scoped>
.it-underline {
  position: relative;
}

.it-underline::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: currentColor;
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.group:hover .it-underline::after {
  transform: scaleX(1);
}
</style>
